<template>
  <div class="header">
    <div class="htop">
      <div class="mborderbtn">
        <img @click="openmbod()" src="@/assets/order.svg" alt="" />
      </div>
      <div class="loginbtn" @click="logindgshow = true" v-if="!this.$store.state.user_token">
        <span>登录</span>
        <span class="line">|</span>
        <span>注册</span>
      </div>
      <div class="loginbtn" @click="tousercenter()" v-if="this.$store.state.user_token">个人中心</div>
    </div>
    <div class="logos">
      <img src="@/assets/hdlogo.png" alt="" />
    </div>
    <div class="htabs">
      <div class="tabsbox">
        <span class="findex" @click="tofindex()" :class="tabindex == -1 ? 'findex_in' : ''">
          <span class="tbnames">首页</span>
        </span>
        <div class="boxli" :class="tabindex == item.id || this.cid == item.id ? 'boxliact' : ''" v-for="(item, index) in tablist" :key="index" @click="settab(item.id, index)">
          <div class="tbnames">
            <span>{{ item.name }}</span>
            <img class="wjiantou" :class="tabindex == item.id ? 'showwicon' : ''" v-if="item.id == 6 || item.id == 17" src="@/assets/xiajiantoufff.svg" alt="" />
            <img class="bjiantou" :class="tabindex == item.id ? 'showbicon' : ''" v-if="item.id == 6 || item.id == 17" src="@/assets/xiajiantoufff.svg" alt="" />
          </div>
          <div class="clist" v-if="item.id == 6 || item.id == 17">
            <span v-for="(tc, t) in item.child" :key="t" @click="settab(tc.id)">{{ tc.name }}</span>
          </div>
        </div>
        <span class="findex" @click="topromybox()" :class="tabindex == -2 ? 'findex_in' : ''">
          <span class="tbnames">维权模块</span>
        </span>
      </div>
    </div>
    <div class="hsearch" v-if="this.$route.path == '/'">
      <div class="searchbox">
        <span class="bleft" @click="sctabshow = !sctabshow"
          >{{ sctabvalue }}
          <img src="@/assets/jiantouxia.svg" alt="" />
          <span class="line"></span>
          <div class="scboxli" v-if="sctabshow">
            <span class="lis" v-for="(item, index) in scboxlist" :key="index" @click="tosetscid(item)">{{ item.name }}</span>
          </div>
        </span>
        <span class="sinput">
          <input v-model="toseachform.scinput" type="text" style="outline: none" placeholder="请输入您要搜索的内容" />
        </span>
        <span class="bright" @click="toseach()">
          <img src="@/assets/searchicon.svg" alt="" />
          搜索
        </span>
      </div>
    </div>

    <a-drawer :visible="openod" :closable="false" class="mborders" style="background-color: #1578d5b1; padding-top: 40px" placement="left" width="120" @close="openod = false">
      <div class="findex" style="margin-bottom: 20px" @click="tofindex()">首页</div>
      <div class="boxlis" style="display: flex; height: 40px; z-index: 99999999" v-for="(item, index) in tablist" :key="index" @click="settab(item.id)">
        <div class="tbnames" style="position: relative">
          {{ item.name }}
        </div>
      </div>
    </a-drawer>
    <div class="loginbox" v-if="logindgshow">
      <div class="mask" @click="logindgshow = false"></div>
      <div class="boxinfo">
        <img src="@/assets/loginimg.png" alt="" />
        <span class="rightbox">
          <span class="logintext">登录</span>
          <span class="checkuser">
            <span class="checkli" :class="checkindex == index ? 'checkliact' : ''" v-for="(item, index) in checkuserlist" :key="index" @click="tocheck(index)">{{ item }}</span>
          </span>
          <span class="inputbox">
            <span class="inl">
              <img src="@/assets/loginusericon.svg" alt="" />
            </span>
            <input v-model="lname" type="text" placeholder="请输入手机号" />
          </span>
          <span class="inputbox">
            <span class="inl"><img src="@/assets/loginpsdicon.svg" alt="" /></span>
            <input v-model="lpassword" type="password" placeholder="请输入密码" />
          </span>
          <span class="newbtn" @click="toregister()">新用户注册</span>
          <span class="loginbtn" @click="tologin()">立即登录</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import bus from "@/api/bus";
import { message } from "ant-design-vue";
export default {
  data() {
    return {
      ctabsindex: 0,
      openod: false,
      tabindex: -1,
      tablist: [],
      childli: [],
      checkuserlist: ["企业", "个人"],
      ctabshow: true,
      visible: true,
      logindgshow: false,
      checkindex: 0,
      lname: "",
      lpassword: "",
      scboxlist: [
        { name: "找专利", id: 6 },
        { name: "找成果", id: 18 },
        { name: "找专家", id: 19 },
        { name: "找需求", id: 11 },
        { name: "找政策", id: 20 }
      ],
      sctabshow: false,
      sctabvalue: "找专利",
      scinput: "",
      toseachform: {
        scinput: "",
        toseachid: 6
      },
      cid: ""
    };
  },
  computed: {},
  created() {},
  mounted() {
    bus.on("login", (val) => {
      this.logindgshow = true;
    });
    this.utokens = localStorage.getItem("user_token");
    this.getcid();
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        if (val.path == "/") {
          this.tabindex = -1;
        }
        if (val.path == "/promybox/index") {
          this.tabindex = -2;
        }
        if (val.query.category_id) {
          this.tabindex = val.query.category_id;
          if (val.query.category_id == 18 || val.query.category_id == 19) {
            this.tabindex = 17;
          }
          if (val.query.category_id == 2 || val.query.category_id == 3 || val.query.category_id == 4 || val.query.category_id == 5) {
            this.tabindex = 1;
          }
        }
        if (val.query.cid) {
          this.getcid(val);
        }
      },
      deep: true
    },
    "$store.state.tab_list": {
      handler: function (newVal, oldVal) {
        this.tablist = this.$store.state.tab_list;
      }
    }
  },

  methods: {
    getcid() {
      this.tabindex = this.$route.query.cid;
    },
    tosetscid(item) {
      this.toseachform.toseachid = item.id;
      this.sctabvalue = item.name;
    },
    toseach() {
      if (this.toseachform.scinput == "") {
        message.error("请输入搜索内容！");
        return;
      }
      this.tabindex = this.toseachform.toseachid;
      if (this.toseachform.toseachid == 18 || this.toseachform.toseachid == 19) {
        this.tabindex = 17;
      }
      this.$router.push({
        path: "/list",
        query: {
          inputv: this.toseachform.scinput,
          category_id: this.toseachform.toseachid
        }
      });
      this.toseachform.scinput = "";
    },
    tofindex() {
      this.ctabshow = false;
      this.tabindex = -1;
      if (this.openmbod) {
        this.openod = false;
      }
      this.$router.push({ name: "index" });
    },
    topromybox() {
      this.ctabshow = false;
      this.tabindex = -2;
      if (this.openmbod) {
        this.openod = false;
      }
      this.$router.push({ name: "promybox" });
    },
    openmbod() {
      this.openod = true;
    },
    tocheck(i) {
      this.checkindex = i;
    },
    settab(i, index) {
      if (i == 17 || index == 1) {
        return;
      }
      this.tabindex = i;
      if (i == 18 || i == 19) {
        this.tabindex = 17;
      }
      this.ctabshow = true;
      // this.childli = child;
      this.openod = false;
      this.$router.push({ path: "/list", query: { category_id: i } });
    },
    toregister() {
      this.logindgshow = false;
      this.$router.push({ name: "register" });
    },
    tologin() {
      if (this.lname == "" || this.lpassword == "") {
        message.error("请检查手机号和密码！");
        return;
      }
      this.$api.post({
        url: "auth/login",
        data: {
          phone: this.lname,
          password: this.lpassword
        },
        success: (res) => {
          // localStorage.setItem("user_token", res.data.access_token);
          this.$store.commit("login", res.data.access_token);
          this.logindgshow = false;
          message.success("登录成功！");

          setTimeout(() => {
            this.$router.push({ name: "usercenter" });
          }, 500);

          // this.tablist = res.data;
        }
      });
    },
    tousercenter() {
      this.tabindex = "";
      this.$router.push({ name: "usercenter" });
    }
  },
  components: {
    bus
  }
};
</script>

<style scoped lang="scss">
// @media all and (max-width: 1200px) {
//   .header {
//     padding-top: 20px !important;
//     padding-bottom: 10px !important;
//     .htop {
//       justify-content: space-between !important;
//       font-size: 16px !important;
//       .mborderbtn {
//         display: block !important;
//       }
//     }
//     .logos {
//       width: 50% !important;
//       img {
//         width: 20% !important;
//       }
//     }
//     .hsearch {
//       .searchbox {
//         margin-top: 30px !important;
//         width: 80% !important;
//         height: 40px !important;
//         font-size: 14px !important;
//         .bleft {
//           margin-left: -4px !important;
//           cursor: pointer;
//         }
//         .line {
//           width: 1px !important;
//           height: 30px !important;
//         }
//         img {
//           width: 14px !important;
//           margin: 0 3px !important;
//         }
//         .bright {
//           cursor: pointer;
//           img {
//             margin-left: -8px !important;
//           }
//         }
//       }
//     }
//     .htabs {
//       background: none !important;
//       margin-top: unset !important;
//       height: 0 !important;
//       .tabsbox {
//         display: none !important;
//       }
//       .ctabs {
//         width: 100% !important;
//         font-size: 14px !important;
//         padding-left: 0 !important;
//         margin-top: 80px !important;
//         height: 60px !important;
//         padding: 20px !important;
//         .tabsli {
//           display: flex;
//           margin-right: 10px !important;
//           cursor: pointer;
//           .dline {
//             margin-left: 5px !important;
//           }
//         }
//       }
//     }
//   }
// }
.header {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 0px;
  min-width: 1000px;
  .htop {
    width: 95%;
    display: flex;
    align-items: center;
    justify-content: end;
    font-size: 18px;
    color: #fff;
    .mborderbtn {
      display: none;
      z-index: 9;
      img {
        width: 30px;
      }
    }
    .loginbtn {
      z-index: 99999;
      margin-top: 20px;
      cursor: pointer;
      span {
        font-size: 18px !important;
      }
      .line {
        margin: 0 5px;
      }
    }
  }
  .logos {
    display: flex;
    justify-content: center;
    img {
      width: 50%;
    }
  }
  .hsearch {
    margin-top: 60px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .searchbox {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 40px;
      margin-bottom: 80px;
      padding-left: 20px;
      width: 34%;
      min-width: 600px;
      height: 60px;
      font-size: 16px;
      color: #1477d8;
      background: #fff;
      border-radius: 35px;
      // overflow: hidden;
      .bleft {
        display: flex;
        align-items: center;
        position: relative;
        cursor: pointer;
        width: 140px;
        font-weight: bold;
        img {
          width: 18px;
          margin-left: 3px;
          margin-right: 10px;
        }
        .line {
          display: block;
          width: 2px;
          height: 40px;
          background: linear-gradient(#fff, #1477d8, #fff);
        }
        .scboxli {
          position: absolute;
          width: 100px;
          display: flex;
          flex-direction: column;
          align-items: center;
          top: 60px;
          left: -14px;
          z-index: 9999999999999999999;
          border-radius: 10px;
          background: #fff;
          .lis {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 16px;
            width: 100%;
            height: 50px;
            cursor: pointer;
          }
          .lis:hover {
            color: #ff0000;
          }
        }
      }
      .sinput {
        width: 100%;
        input {
          width: 90%;
          border: none;
          margin-left: 2px;
        }
      }
      .bright {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 160px;
        height: 100%;
        background: #1477d8;
        color: #fff;
        font-size: 16px;
        border-radius: 0 35px 35px 0;
        font-weight: bold;
        cursor: pointer;
        img {
          width: 26px;
          margin-right: 5px;
          margin-left: -8px;
        }
      }
    }
  }
  .htabs {
    margin-top: 100px;
    width: 80%;
    height: 60px;
    background: #2145a6;
    font-size: 18px;
    z-index: 999999999;
    min-width: 1000px;
    .tabsbox {
      width: 100%;
      height: 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 auto;
      .findex {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        // width: 90px;
        height: 100%;
        line-height: 40px;
        cursor: pointer;
        .tbnames {
          display: flex;
          justify-content: center;
          align-items: center;
          line-height: 40px;
        }
      }
      .findex:hover {
        background: #cc494f;
      }
      .findex_in {
        background: #cc494f;
        color: #fff;
        font-weight: bold;
        .tbnames {
          border-bottom: 2px solid #fff;
        }
      }
      .boxli {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        height: 60px;
        // width: 150px;
        cursor: pointer;
        .tbnames {
          display: flex;
          justify-content: center;
          align-items: center;
          line-height: 40px;
          // height: 100%;
          // width: 60%;

          .wjiantou {
            width: 18px;
            margin-left: 5px;
          }
          .bjiantou {
            width: 18px;
            display: none;
          }
          .showbicon {
            display: block !important;
          }
          .showwicon {
            display: none !important;
          }
        }

        .clist {
          display: none !important;
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          position: absolute;
          top: 60px;
          background: #2145a6;
          cursor: pointer;
          span {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 60px;
            display: flex;
            justify-content: center;
          }
        }
      }
      .boxliact {
        background: #cc494f;
        color: #fff;
        font-weight: bold;
        .tbnames {
          border-bottom: 2px solid #fff;
        }
      }
      .boxli:hover {
        background: #cc494f;
        display: flex;
        .tbnames {
          .wjiantou {
            display: none !important;
          }
          .bjiantou {
            display: block !important;
          }
        }

        .clist {
          display: block !important;
          span:hover {
            color: #fff;
            background: #1477d8;
          }
        }
      }
    }
    .ctabs {
      width: 80%;
      height: 60px;
      display: flex;
      justify-self: start;
      align-items: center;
      color: #8c8c8c;
      margin: 15px auto;
      border-bottom: 1px solid #a4a4a4;
      .tabsli {
        display: flex;
        margin-right: 20px;
        cursor: pointer;
        margin-top: 20px;
        .dline {
          margin-left: 10px;
        }
        .tabsliact {
          color: #1477d8;
        }
      }
    }
  }
  .mborders {
    z-index: 999999999;
  }
  .loginbox {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 99999999999;
    top: 0;
    .mask {
      width: 100%;
      height: 100%;
      z-index: 999999999999;
      background: rgba(32, 32, 32, 0.703);
    }
    .boxinfo {
      position: absolute;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 1000px;
      height: 600px;
      background: #fff;
      z-index: 9999999999999;
      border-radius: 10px;
      overflow: hidden;
      color: #333;
      img {
        height: 100%;
      }
      .rightbox {
        width: 55%;
        height: 80%;
        display: flex;
        flex-direction: column;
        align-items: center;
        // justify-content: space-between;
        .logintext {
          width: 80%;
          text-align: center;
          font-size: 24px;
        }
        .checkuser {
          width: 80%;
          display: flex;
          justify-content: start;
          margin: 30px 0;
          .checkli {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 75px;
            height: 40px;
            border: 1px solid #d9d9d9;
            cursor: pointer;
          }
          .checkli:nth-child(2) {
            border-left: none;
          }
          .checkliact {
            background: #1477d8;
            color: #fff;
          }
        }
        .inputbox {
          width: 80%;
          height: 50px;
          display: flex;
          margin-bottom: 20px;
          .inl {
            border-left: 1px solid #d9d9d9;
            border-top: 1px solid #d9d9d9;
            border-bottom: 1px solid #d9d9d9;
            padding: 5px 18px;
            border-right: nonoe;
            img {
              width: 18px;
            }
          }
          input {
            width: 100%;
            border: 1px solid #d9d9d9;
            padding-left: 10px;
            outline: none;
          }
        }
        .newbtn {
          width: 80%;
          font-size: 18px;
          color: #1477d8;
          margin-top: 10px;
          cursor: pointer;
        }
        .loginbtn {
          margin-top: 50px;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 80%;
          height: 60px;
          background: #1477d8;
          color: #fff;
          font-size: 18px;
          border-radius: 10px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
